import { useRouter } from 'next/router';
import styled from 'styled-components';
import Head from '~/components/Head';
import Layout from '~/components/Layout';
import MenuNav from '~/components/MenuNav';
import SearchArtists, { useArtistSearchCount } from '~/components/SearchArtists';
import SearchObjkts from '~/components/SearchObjkts';
import { useSearchObjktsCount } from '~/hooks/useSearchObjkts';
import { formatAmount } from '~/utils';

type PageParams = {
  q: string;
  section: 'artists';
  showBanned: string;
};

const Menu = () => {
  const router = useRouter();
  const { q, section, showBanned } = router.query as PageParams;
  const objktCount = useSearchObjktsCount();
  const artistCount = useArtistSearchCount(q, !!showBanned);
  return (
    <MenuNav
      label="Search type"
      sections={
        [
          {
            label: `Objkts${objktCount.countLoading ? '' : objktCount.count ? ` (${formatAmount(objktCount.count, 0)})` : ''}`,
            url: `/search${q ? `?q=${q}` : ''}`,
            isActive: !section,
          },
          {
            label: `Artists${artistCount.countLoading ? '' : artistCount.count ? ` (${formatAmount(artistCount.count, 0)})` : ''}`,
            url: `/search/artists${q ? `?q=${q}` : ''}`,
            isActive: section === 'artists',
          },
        ]
      }
    />
  );
};

const ListContainer = styled.div``;

const Page = () => {
  const router = useRouter();
  const { q, section } = router.query as PageParams;
  return (
    <Layout>
      <Head title={ `${q ? `${q} - ` : ''}search HIC.AF` } />
      <Menu />
      <ListContainer>
        {
          section === 'artists' ? (
            <SearchArtists />
          ) : (
            <SearchObjkts />
          )
        }
      </ListContainer>
    </Layout>
  );
};

export default Page;
